import { useContext, useEffect } from 'react'

import { ConnectedUserContext } from 'components'
import { useAccountContext } from 'components/contexts/AccountContext'

const LoggerContextInitializer = ({ children }) => {
  const connectedUser = useContext(ConnectedUserContext)
  const { accountKey: selectedAccountKey, orgId: selectedPbxId } = useAccountContext()

  useEffect(() => {
    try {
      if (window.goToAdminLogger) {
        window.goToAdminLogger.setAccountContext(selectedAccountKey!, connectedUser?.key || '', selectedPbxId!)
      }
    } catch (e) {
      console.error('Unable to initialize logger account info', e)
    }
  }, [connectedUser, selectedAccountKey, selectedPbxId])

  return <>{children}</>
}

export default LoggerContextInitializer
